export function MapValues<T extends Record<string, any>, U>(
	obj: T,
	fn: (value: T[keyof T], key: keyof T) => U
): { [K in keyof T]: U } {
	/* eslint-disable */
	//@ts-ignore
	return Object.entries(obj).reduce(
		(acc, [key, val]) => {
			acc[key as keyof T] = fn(val, key)
			return acc
		},
		{} as { [K in keyof T]: U }
	)
}

export function Omit<T extends Record<string, any>, K extends keyof T>(
	obj: T,
	...keys: K[]
): Omit<T, K> {
	/* eslint-disable */
	//@ts-ignore
	return Object.entries(obj).reduce(
		(acc, [k, v]) => {
			/* eslint-disable */
			//@ts-ignore
			if (!keys.includes(k as K)) {
				;(acc as any)[k] = v
			}
			return acc
		},
		{} as Omit<T, K>
	)
}

export function Pick<T extends Record<string, any>, K extends keyof T>(
	obj: T,
	...keys: K[]
): Pick<T, K> {
	/* eslint-disable */
	//@ts-ignore
	return Object.entries(obj).reduce(
		(acc, [k, v]) => {
			/* eslint-disable */
			//@ts-ignore
			if (keys.includes(k as K)) {
				;(acc as any)[k] = v
			}
			return acc
		},
		{} as Pick<T, K>
	)
}

export function OmitBy<T extends Record<string, any>>(
	obj: T,
	fn: (value: T[keyof T], key: keyof T) => bool
): Partial<T> {
	/* eslint-disable */
	//@ts-ignore
	return Object.entries(obj).reduce((acc, [k, v]) => {
		if (!fn(v, k)) {
			acc[k as keyof T] = v
		}
		return acc
	}, {} as Partial<T>)
}
